export const text = {
    pageTitle: "OCR PDF",
    errorMsg: "مشکلی پیش آمده، لطفا دوباره تلاش کنید.",
    dragMsg: "Drag and Drop Files Here or Click to Select",
    uploadingMsg: "Uploading File...",
    onlyAudioMsg: "Only PDFs Are Accepted.",
    textPlaceholder: "The text will be shown here!",
}
